var _path, _path2, _path3, _path4, _g, _g2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFingerUp = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#finger-up_svg__clip0_739_114)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#finger-up_svg__filter0_iii_739_114)",
  fillRule: "evenodd",
  clipRule: "evenodd"
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18.14 16.264l-2.372.678-8.132 1.016h-.339v7.454s-.528 13.892 11.86 13.892c12.85 0 12.536-12.198 12.536-12.198l-1.694-4.404s-.34-5.645-.34-7.793V4.405C29.66 3.128 29.382 0 26.61 0c-3.348 0-3.05 4.066-3.05 4.066v7.454s.42 3.389-.338 3.389c-.757 0-5.082 1.355-5.082 1.355z",
  fill: "#FFCE46"
})), /*#__PURE__*/React.createElement("path", {
  d: "M18.14 16.264l-2.372.678-8.132 1.016h-.339v7.454s-.528 13.892 11.86 13.892c12.85 0 12.536-12.198 12.536-12.198l-1.694-4.404s-.34-5.645-.34-7.793V4.405C29.66 3.128 29.382 0 26.61 0c-3.348 0-3.05 4.066-3.05 4.066v7.454s.42 3.389-.338 3.389c-.757 0-5.082 1.355-5.082 1.355z",
  fill: "url(#finger-up_svg__paint0_linear_739_114)",
  style: {
    mixBlendMode: "overlay"
  }
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#finger-up_svg__filter1_iii_739_114)",
  fillRule: "evenodd",
  clipRule: "evenodd"
}, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.429 12.643c1.643 0 2.604 1.07 2.71 2.033.106.964.352 3.697.34 4.744-.013 1.046-.866 3.727-2.711 3.727-1.847 0-2.711-1.174-2.711-2.033 0-.86-.32-5.107-.339-5.76-.02-.653.453-2.71 2.71-2.71z",
  fill: "#FFCE46"
})), /*#__PURE__*/React.createElement("path", {
  d: "M15.429 12.643c1.643 0 2.604 1.07 2.71 2.033.106.964.352 3.697.34 4.744-.013 1.046-.866 3.727-2.711 3.727-1.847 0-2.711-1.174-2.711-2.033 0-.86-.32-5.107-.339-5.76-.02-.653.453-2.71 2.71-2.71z",
  fill: "url(#finger-up_svg__paint1_linear_739_114)",
  style: {
    mixBlendMode: "overlay"
  }
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#finger-up_svg__filter2_iii_739_114)",
  fillRule: "evenodd",
  clipRule: "evenodd"
}, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.008 13.998c1.547 0 2.536.463 2.71 2.034.114 1.023.334 1.547.339 3.388.005 1.84-1.054 3.05-2.71 3.05-1.657 0-3.05-.79-3.05-2.034v-4.404c0-1.333 1.02-2.034 2.71-2.034z",
  fill: "#FFCE46"
})), /*#__PURE__*/React.createElement("path", {
  d: "M10.008 13.998c1.547 0 2.536.463 2.71 2.034.114 1.023.334 1.547.339 3.388.005 1.84-1.054 3.05-2.71 3.05-1.657 0-3.05-.79-3.05-2.034v-4.404c0-1.333 1.02-2.034 2.71-2.034z",
  fill: "url(#finger-up_svg__paint2_linear_739_114)",
  style: {
    mixBlendMode: "overlay"
  }
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#finger-up_svg__filter3_iii_739_114)",
  fillRule: "evenodd",
  clipRule: "evenodd"
}, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M20.848 11.859c1.643 0 2.943 1.07 3.05 2.033.105.963.35 4.375.338 5.421-.012 1.047-1.203 3.727-3.05 3.727-1.845 0-2.71-1.174-2.71-2.033s-.32-5.785-.339-6.438c-.02-.652.453-2.71 2.71-2.71z",
  fill: "#FFCE46"
})), /*#__PURE__*/React.createElement("path", {
  d: "M20.848 11.859c1.643 0 2.943 1.07 3.05 2.033.105.963.35 4.375.338 5.421-.012 1.047-1.203 3.727-3.05 3.727-1.845 0-2.71-1.174-2.71-2.033s-.32-5.785-.339-6.438c-.02-.652.453-2.71 2.71-2.71z",
  fill: "url(#finger-up_svg__paint3_linear_739_114)",
  style: {
    mixBlendMode: "overlay"
  }
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#finger-up_svg__filter4_f_739_114)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.896 27.954l-.677-2.033-1.017-.678-2.71-.339-2.033-.339-1.017-.338v.677s.398.396.678.678c.28.282 1.694.678 1.694.678l2.033.338h1.016l1.017.678 1.016.678z",
  fill: "#231F20",
  fillOpacity: 0.5
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#finger-up_svg__filter5_f_739_114)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.896 27.954l-.677-2.033-1.017-.678-2.71-.339-2.033-.339-1.017-.338v.677s.398.396.678.678c.28.282 1.694.678 1.694.678l2.033.338h1.016l1.017.678 1.016.678z",
  fill: "#231F20"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "finger-up_svg__a",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 13,
  y: 19,
  width: 22,
  height: 16
}, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.71 26.977l-2.271-.631-4.194-.796-2.362-1.723v-4.344h11.453l1.456.807 2.737.826 1.546 2.494 1.607 2.387 1.209 5.069.955 3.517-11.423-6.824-.712-.782z",
  fill: "#D8D8D8"
}))), /*#__PURE__*/React.createElement("g", {
  filter: "url(#finger-up_svg__filter6_iii_739_114)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  mask: "url(#finger-up_svg__a)"
}, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M15.425 20.33c.738-.28 2.27.093 3.728 0 1.457-.095 2.139-.34 3.388-.34 1.25 0 3.834.896 4.744 1.356.91.46 2.03 1.184 2.71 1.694.68.51 1.651 1.457 1.694 4.066.044 2.61-1.412 5.847-2.371 7.116-.96 1.268-6.777 3.05-6.777 3.05l-8.81-2.373-.677-4.066 6.776 1.017 4.405-.339-.677-3.388s.11-2.711-2.034-2.711c-2.143 0-3.23-.127-4.066-.339-.835-.212-2.111-1.085-2.371-1.694-.27-.632-.614-2.69.338-3.05z",
  fill: "#FFCE46"
})), /*#__PURE__*/React.createElement("path", {
  d: "M15.425 20.33c.738-.28 2.27.093 3.728 0 1.457-.095 2.139-.34 3.388-.34 1.25 0 3.834.896 4.744 1.356.91.46 2.03 1.184 2.71 1.694.68.51 1.651 1.457 1.694 4.066.044 2.61-1.412 5.847-2.371 7.116-.96 1.268-6.777 3.05-6.777 3.05l-8.81-2.373-.677-4.066 6.776 1.017 4.405-.339-.677-3.388s.11-2.711-2.034-2.711c-2.143 0-3.23-.127-4.066-.339-.835-.212-2.111-1.085-2.371-1.694-.27-.632-.614-2.69.338-3.05z",
  fill: "url(#finger-up_svg__paint4_linear_739_114)",
  style: {
    mixBlendMode: "overlay"
  }
})), /*#__PURE__*/React.createElement("g", {
  style: {
    mixBlendMode: "soft-light"
  },
  filter: "url(#finger-up_svg__filter7_f_739_114)"
}, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.103 15.925l-1.356.34-.677.677-.339 2.71 1.016.34h1.356l1.016-.34v-1.355l-.338-1.016-.678-1.356z",
  fill: "#fff",
  fillOpacity: 0.5
}))), /*#__PURE__*/React.createElement("g", {
  style: {
    mixBlendMode: "soft-light"
  },
  filter: "url(#finger-up_svg__filter8_f_739_114)"
}, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.863 14.57l-1.355.367-.677.735-.34 2.936 1.017.367h1.355l1.017-.367V17.14l-.339-1.101-.678-1.469z",
  fill: "#fff",
  fillOpacity: 0.5
}))), /*#__PURE__*/React.createElement("g", {
  style: {
    mixBlendMode: "soft-light"
  },
  filter: "url(#finger-up_svg__filter9_f_739_114)"
}, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.962 3.388l-1.355-1.694-1.356 1.694V19.06l-.338 2.936 1.016.367h1.355l1.017-.367v-1.468l-.339-1.1V3.387z",
  fill: "#fff",
  fillOpacity: 0.5
}))), /*#__PURE__*/React.createElement("g", {
  style: {
    mixBlendMode: "soft-light"
  },
  filter: "url(#finger-up_svg__filter10_f_739_114)"
}, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.988 16.603L8.31 17.62l-.34 2.372 1.357.338h1.016l1.016-.677v-1.356l-.339-1.016-1.016-1.017-1.016.339z",
  fill: "#fff",
  fillOpacity: 0.5
}))), /*#__PURE__*/React.createElement("g", {
  style: {
    mixBlendMode: "soft-light"
  },
  filter: "url(#finger-up_svg__filter11_f_739_114)"
}, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.186 21.346h-4.744l-.678.339.34.678 1.015.677 1.356.34h3.727l1.016.338.678.678 1.017 1.355.677 1.355v1.356l-1.016 2.71 2.371 1.356 1.695-1.017 1.355-3.05V26.43l-.678-1.694-1.016-1.356-1.694-.678-1.355-.677-1.695-.678h-2.371z",
  fill: "#fff",
  fillOpacity: 0.5
}))), /*#__PURE__*/React.createElement("g", {
  style: {
    mixBlendMode: "soft-light"
  },
  filter: "url(#finger-up_svg__filter12_f_739_114)"
}, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.004 28.462v2.372l.678 2.71 2.033 1.356 1.355.678 2.71 1.016 2.372.339 2.033-.34 1.695-.677-.678-2.71-.678-1.356-1.016-1.355h-3.05l-2.033-1.355-2.033-1.017-2.033-1.017-1.355 1.356z",
  fill: "#fff",
  fillOpacity: 0.5
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "finger-up_svg__filter0_iii_739_114",
  x: 7.294,
  y: -2.033,
  width: 24.4,
  height: 41.676,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -2.033
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.016
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.831373 0 0 0 0 0.513726 0 0 0 0 0.00392157 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_739_114"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -0.339
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.169
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.6 0 0 0 0 0.227451 0 0 0 0 0 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_innerShadow_739_114",
  result: "effect2_innerShadow_739_114"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.339
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.508
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.819608 0 0 0 0 0.533333 0 0 0 0 0.0313726 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect2_innerShadow_739_114",
  result: "effect3_innerShadow_739_114"
})), /*#__PURE__*/React.createElement("filter", {
  id: "finger-up_svg__filter1_iii_739_114",
  x: 12.717,
  y: 10.61,
  width: 5.761,
  height: 12.876,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -2.033
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.016
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.831373 0 0 0 0 0.513726 0 0 0 0 0.00392157 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_739_114"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -0.339
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.169
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.6 0 0 0 0 0.227451 0 0 0 0 0 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_innerShadow_739_114",
  result: "effect2_innerShadow_739_114"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.339
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.508
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.819608 0 0 0 0 0.533333 0 0 0 0 0.0313726 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect2_innerShadow_739_114",
  result: "effect3_innerShadow_739_114"
})), /*#__PURE__*/React.createElement("filter", {
  id: "finger-up_svg__filter2_iii_739_114",
  x: 7.297,
  y: 11.966,
  width: 5.76,
  height: 10.842,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -2.033
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.016
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.831373 0 0 0 0 0.513726 0 0 0 0 0.00392157 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_739_114"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -0.339
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.169
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.6 0 0 0 0 0.227451 0 0 0 0 0 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_innerShadow_739_114",
  result: "effect2_innerShadow_739_114"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.339
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.508
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.819608 0 0 0 0 0.533333 0 0 0 0 0.0313726 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect2_innerShadow_739_114",
  result: "effect3_innerShadow_739_114"
})), /*#__PURE__*/React.createElement("filter", {
  id: "finger-up_svg__filter3_iii_739_114",
  x: 18.137,
  y: 9.826,
  width: 6.1,
  height: 13.553,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -2.033
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.016
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.831373 0 0 0 0 0.513726 0 0 0 0 0.00392157 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_739_114"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -0.339
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.169
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.6 0 0 0 0 0.227451 0 0 0 0 0 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_innerShadow_739_114",
  result: "effect2_innerShadow_739_114"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.339
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.508
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.819608 0 0 0 0 0.533333 0 0 0 0 0.0313726 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect2_innerShadow_739_114",
  result: "effect3_innerShadow_739_114"
})), /*#__PURE__*/React.createElement("filter", {
  id: "finger-up_svg__filter4_f_739_114",
  x: 14.6,
  y: 22.384,
  width: 11.139,
  height: 7.411,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.921,
  result: "effect1_foregroundBlur_739_114"
})), /*#__PURE__*/React.createElement("filter", {
  id: "finger-up_svg__filter5_f_739_114",
  x: 14.6,
  y: 22.384,
  width: 11.139,
  height: 7.411,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.921,
  result: "effect1_foregroundBlur_739_114"
})), /*#__PURE__*/React.createElement("filter", {
  id: "finger-up_svg__filter6_iii_739_114",
  x: 13.054,
  y: 17.958,
  width: 18.637,
  height: 19.652,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -2.033
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.016
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.831373 0 0 0 0 0.513726 0 0 0 0 0.00392157 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_739_114"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -0.339
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.169
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.6 0 0 0 0 0.227451 0 0 0 0 0 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_innerShadow_739_114",
  result: "effect2_innerShadow_739_114"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.339
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.508
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.819608 0 0 0 0 0.533333 0 0 0 0 0.0313726 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect2_innerShadow_739_114",
  result: "effect3_innerShadow_739_114"
})), /*#__PURE__*/React.createElement("filter", {
  id: "finger-up_svg__filter7_f_739_114",
  x: 10.047,
  y: 12.241,
  width: 10.757,
  height: 11.435,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.842,
  result: "effect1_foregroundBlur_739_114"
})), /*#__PURE__*/React.createElement("filter", {
  id: "finger-up_svg__filter8_f_739_114",
  x: 15.807,
  y: 10.886,
  width: 10.757,
  height: 11.773,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.842,
  result: "effect1_foregroundBlur_739_114"
})), /*#__PURE__*/React.createElement("filter", {
  id: "finger-up_svg__filter9_f_739_114",
  x: 21.228,
  y: -1.99,
  width: 10.757,
  height: 28.037,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.842,
  result: "effect1_foregroundBlur_739_114"
})), /*#__PURE__*/React.createElement("filter", {
  id: "finger-up_svg__filter10_f_739_114",
  x: 4.287,
  y: 12.58,
  width: 10.757,
  height: 11.435,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.842,
  result: "effect1_foregroundBlur_739_114"
})), /*#__PURE__*/React.createElement("filter", {
  id: "finger-up_svg__filter11_f_739_114",
  x: 12.08,
  y: 17.662,
  width: 21.599,
  height: 18.55,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.842,
  result: "effect1_foregroundBlur_739_114"
})), /*#__PURE__*/React.createElement("filter", {
  id: "finger-up_svg__filter12_f_739_114",
  x: 6.32,
  y: 23.422,
  width: 20.244,
  height: 17.195,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.842,
  result: "effect1_foregroundBlur_739_114"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finger-up_svg__paint0_linear_739_114",
  x1: 20.86,
  y1: 39.304,
  x2: 20.86,
  y2: 34.903,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.8
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.01
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.01
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finger-up_svg__paint1_linear_739_114",
  x1: 15.921,
  y1: 23.147,
  x2: 15.921,
  y2: 21.971,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.8
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.01
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.01
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finger-up_svg__paint2_linear_739_114",
  x1: 10.499,
  y1: 22.469,
  x2: 10.499,
  y2: 21.521,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.8
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.01
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.01
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finger-up_svg__paint3_linear_739_114",
  x1: 21.528,
  y1: 23.04,
  x2: 21.528,
  y2: 21.788,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.8
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.01
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.01
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finger-up_svg__paint4_linear_739_114",
  x1: 23.416,
  y1: 37.271,
  x2: 23.416,
  y2: 35.336,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.8
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.01
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.01
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "finger-up_svg__clip0_739_114"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h40v40H0z"
})))));
export default "data:image/svg+xml;base64,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";
export { SvgFingerUp as ReactComponent };